import { useTranslation } from "react-i18next";
import TableEmptyState from "../../../components/common/tableEmptyState/TableEmptyState";
import styles from "./ExamBaseStudentsModal.module.css";

const ExamBaseStudentsModal = ({ isOpen, onClose, loading, error, students, examBase }) => {
  const { t } = useTranslation();
  if (!isOpen) return null;

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <h3 className={styles.title}>{examBase ? t("pages.examBaseStudents.titleFor", { name: examBase.subjectTitle }) : t("pages.examBaseStudents.titleFallback")}</h3>

        {loading ? (
          <div>{t("common.loading")}</div>
        ) : error ? (
          <div>{error}</div>
        ) : !students || students.length === 0 ? (
          <TableEmptyState
            title={t("pages.examBaseStudents.noStudentsTitle")}
            description={t("pages.examBaseStudents.noStudentsDescription")}
          />
        ) : (
          <table className={styles.table}>
            <thead>
              <tr>
                <th>{t("pages.examBaseStudents.studentNumber")}</th>
                <th>{t("pages.examBaseStudents.firstName")}</th>
                <th>{t("pages.examBaseStudents.lastName")}</th>
              </tr>
            </thead>
            <tbody>
              {students.map((s) => (
                <tr key={s.studentNumber}>
                  <td>{s.studentNumber}</td>
                  <td>{s.firstName}</td>
                  <td>{s.lastName}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}

        <button className={styles.closeButton} onClick={onClose}>
          {t("common.close")}
        </button>
      </div>
    </div>
  );
};

export default ExamBaseStudentsModal;
